import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {of, switchMap} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {RolesService} from "../../../main/pages/users/roles/roles.service";

import * as PermissionsActions from './permission.actions';
import {IRolesDto} from "./permission.reducer";


@Injectable({providedIn:'root'})
export class PermissionEffect {
    constructor(private _actions$: Actions,
                private _rolesService: RolesService
                ) {
    }

    fetchUserRoles$ = createEffect(()=>{
        return this._actions$.pipe(
            ofType(PermissionsActions.fetchRoles),
            switchMap(()=> this._rolesService.fetchRoles()
                .pipe(
                    map((roles)=> PermissionsActions.fetchRolesSucceeded(roles as IRolesDto[])),
                    catchError(error => of(PermissionsActions.fetchRolesFailed(error)))
                )
            )
        )
    });
}